import InboxRulesOptionState from '../store/schema/InboxRulesOptionState';
import { select } from 'satcheljs/lib/legacy';
import store from '../store/store';
import { isValidSection } from '../utils/isValidClause';

export interface IsInboxRuleEditValidState {
    optionState: InboxRulesOptionState;
}
export default select<IsInboxRuleEditValidState>({
    optionState: () => store,
})(function isInboxRuleEditValid(state?: IsInboxRuleEditValidState) {
    return (
        state.optionState.inboxRulesEditState.clauseMap.size > 0 &&
        state.optionState.inboxRulesEditState.ruleName.trim().length > 0 &&
        isValidSection('conditional') &&
        isValidSection('action') &&
        isValidSection('exception')
    );
});
